<ng-container *ngIf="product$">
  <div class="notify-me-modal-container">
    <div class="modal-container">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="modal-basic-title">
            {{ 'stockNotification.outOfStockItemsLabel' | cxTranslate }}
          </h4>
        </div>

        <div class="modal-body">
          <ng-container *ngFor="let product of product$; let productIndex = index">
            <div class="product-info">
              <div class="image">
                <cx-media
                  *ngIf="product?.images; else noImage"
                  [container]="getImageRendition(product.images?.PRIMARY)"
                  format="product"
                  [class.is-missing-fish]="businessType === 'fish'"
                ></cx-media>
                <ng-template #noImage>
                  <cx-media class="cx-no-image is-missing" [class.is-missing-fish]="businessType === 'fish'"></cx-media>
                </ng-template>
              </div>
              <div class="entry-info">
                <div class="code">
                  {{ product.code }}
                </div>
                <div class="name" [innerHTML]="product.name"></div>
              </div>
            </div>

            <ng-container *ngIf="variant$">
              <div class="table">
                <div class="table-container">
                  <hr />
                  <div class="header-container">
                    <ng-container *ngIf="showCategory">
                      <div class="header" *ngFor="let headerName of categoryNames[productIndex]">
                        <span>{{ headerName }}</span>
                      </div>
                    </ng-container>
                    <div class="header" *ngIf="!showSrp">
                      <span>{{ 'stockNotification.priceLabel' | cxTranslate }}</span>
                    </div>
                    <div class="header">
                      <span>{{ 'stockNotification.notifyMeLabel' | cxTranslate }}</span>
                    </div>
                  </div>
                  <hr />
                  <ng-container *ngFor="let variant of variant$">
                    <ng-container *ngIf="compareCodes(variant?.superCategories, product?.superCategories, product)">
                      <div class="categories-info-container">
                        <ng-container *ngIf="showCategory">
                          <ng-container
                            *ngFor="
                              let variantCategoryValue of productCategories(
                                variant.superCategories,
                                categoryNames[productIndex]
                              )
                            "
                          >
                            <div class="product-categories">
                              <div class="value">
                                {{ variantCategoryValue }}
                              </div>
                            </div>
                          </ng-container>
                        </ng-container>
                        <div class="product-price" *ngIf="!showSrp">
                          <div class="value">
                            {{ dealerPrice(variant.code) }}
                          </div>
                        </div>
                        <div class="notify-me">
                          <div class="value">
                            <app-notify-me [productCode]="variant.code" [isModal]="true"></app-notify-me>
                          </div>
                        </div>
                      </div>
                      <hr />
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn secondary-btn cancel-btn mw-120" (click)="closeModal('Cross click')">
            {{ 'modal.close' | cxTranslate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
